import withActDetail from "../withActDetail";
import ActBuyProductsForm from "./ActBuyProductsForm";
import ActBuyProductsPDFGenerator from "./ActProductsPDFGenerator";

const actFormKazakhName = 'Өнімді (тауарды) сатып алу АКТІСІ'
const actFormName = 'АКТ покупки продукции (товара)'
const actFormNumber = '012'
const actName = 'ActBuyProducts'

export default withActDetail(ActBuyProductsForm, ActBuyProductsPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)